import TableOrdenDeVenta from './TableOrdenDeVenta'

export default TableOrdenDeVenta
